import bookCallPopupJson from "@/data/copy/book-call-popup.json";
import { createCopyGetter } from "@/lib/localize-copy";
import type { Lang } from "@/lib/types";

export type BookCallPopupVariant = keyof typeof bookCallPopupJson;

export type BookCallPopupSummaryCopy = {
  eyebrow: string;
  title: string;
  description: string;
  duration: string;
  location: string;
  timezone: string;
};

export type BookCallFormCopyOverrides = {
  notes?: string;
  notesPlaceholder?: string;
  confirm?: string;
  confirmed?: string;
  confirmedBody?: string;
};

/** Values carried from an upstream form (e.g. SEO footer CTA) into the booking step. */
export type BookCallFormPrefill = {
  firstName?: string;
  lastName?: string;
  email?: string;
  company?: string;
  notes?: string;
  /** Maps to the booking form notes field (website URL for SEO). */
  website?: string;
};

export type BookCallPopupCopy = {
  summary: BookCallPopupSummaryCopy;
  form?: BookCallFormCopyOverrides;
};

const getBookCallPopupCopyTree = createCopyGetter(bookCallPopupJson);

export function getBookCallPopupCopy(
  lang: Lang,
  variant: BookCallPopupVariant = "default",
): BookCallPopupCopy {
  const tree = getBookCallPopupCopyTree(lang);
  return tree[variant] ?? tree.default;
}

export function parseBookCallPopupVariant(
  raw: string | undefined | null,
): BookCallPopupVariant {
  const key = raw?.trim();
  if (key && key in bookCallPopupJson) {
    return key as BookCallPopupVariant;
  }
  return "default";
}
